import { STORY } from "@/constants/testIds";
import { Sprout, Leaf, Coffee } from "lucide-react";

const CARDS = [
  {
    icon: Sprout,
    title: "Nigerian Roots",
    body:
      "Sourced from sun-rich farms in Nigeria, where cashew trees grow slowly under generous skies — the way nature intended.",
  },
  {
    icon: Leaf,
    title: "Natural Goodness",
    body:
      "Nothing hidden, nothing artificial. Just the deep, buttery taste of the kernel — slow-roasted in small batches.",
  },
  {
    icon: Coffee,
    title: "Premium Everyday",
    body:
      "Designed for the modern European pantry. From morning rituals to evening pours, NAIJA brings origin to every moment.",
  },
];

export const Story = () => {
  return (
    <section
      id="story"
      data-testid={STORY.wrapper}
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#c5a059]" />
            <span className="overline">Our Story</span>
          </div>
          <h2 className="font-serif-display text-[40px] sm:text-[56px] leading-[1.05] text-[#1a3626] tracking-tight">
            Born in Nigeria. <br className="hidden sm:block" />
            <em className="italic text-[#8b5a2b]">Made for the World.</em>
          </h2>
          <p className="mt-7 text-[16px] sm:text-[18px] leading-[1.7] text-[#5c4033] max-w-2xl">
            NAIJA Cashews was created to bring the richness of Nigerian
            agriculture to modern European snack culture. Every pack represents
            more than a snack: it represents origin, pride, quality and
            opportunity.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <article
                key={i}
                data-testid={STORY.card(i)}
                className="group relative bg-[#fdfaf4] border border-[#c5a059]/20 rounded-[2rem] p-9 lg:p-10 shadow-[0_8px_30px_rgba(26,54,38,0.05)] hover:shadow-[0_20px_50px_rgba(26,54,38,0.1)] hover:-translate-y-1 transition-all duration-500"
              >
                <div className="w-12 h-12 rounded-full bg-[#1a3626] text-[#c5a059] flex items-center justify-center shadow-[0_6px_18px_rgba(26,54,38,0.18)]">
                  <Icon size={20} />
                </div>
                <div className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[#8b5a2b]">
                  0{i + 1}
                </div>
                <h3 className="mt-2 font-serif-display text-[28px] text-[#1a3626] tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-3 text-[15px] leading-[1.7] text-[#5c4033]">
                  {c.body}
                </p>
                <div className="mt-7 flex items-center gap-3 text-[#1a3626]/40 group-hover:text-[#c5a059] transition-colors">
                  <span className="h-px w-8 bg-current" />
                  <span className="text-[11px] uppercase tracking-[0.22em]">
                    NAIJA
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
